/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBuildings = createReactComponent("outline", "buildings", "IconBuildings", [["path", { "d": "M4 21v-15c0 -1 1 -2 2 -2h5c1 0 2 1 2 2v15", "key": "svg-0" }], ["path", { "d": "M16 8h2c1 0 2 1 2 2v11", "key": "svg-1" }], ["path", { "d": "M3 21h18", "key": "svg-2" }], ["path", { "d": "M10 12v0", "key": "svg-3" }], ["path", { "d": "M10 16v0", "key": "svg-4" }], ["path", { "d": "M10 8v0", "key": "svg-5" }], ["path", { "d": "M7 12v0", "key": "svg-6" }], ["path", { "d": "M7 16v0", "key": "svg-7" }], ["path", { "d": "M7 8v0", "key": "svg-8" }], ["path", { "d": "M17 12v0", "key": "svg-9" }], ["path", { "d": "M17 16v0", "key": "svg-10" }]]);

export { IconBuildings as default };
//# sourceMappingURL=IconBuildings.mjs.map
